import { alpha } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

import { BANNER_VARIANT } from './const';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: theme.spacing(1),
      backgroundColor: COLORS.primary.active,

      [`&[data-variant="${BANNER_VARIANT.header}"]`]: {
        padding: theme.spacing(1, 2),

        '& $texts': {
          flexFlow: 'row',
          alignItems: 'center',
        },
      },

      [`&[data-variant="${BANNER_VARIANT.banner}"]`]: {
        padding: theme.spacing(2, 3),
        borderRadius: theme.shape.borderRadius,

        '& $texts': {
          flex: 1,
          flexFlow: 'column',
          gap: theme.spacing(0.5),
        },
      },

      [`&[data-variant="${BANNER_VARIANT.medium}"]`]: {
        padding: theme.spacing(1, 3),

        '& $texts': {
          flexFlow: 'column',
          alignItems: 'flex-start',
          gap: theme.spacing(0.5),
        },

        '& $content': {
          justifyContent: 'space-between',
        },
      },

      [`&[data-variant="${BANNER_VARIANT.small}"]`]: {
        padding: theme.spacing(1.5),
        borderRadius: theme.shape.borderRadiusSmall,

        '& $content': {
          justifyContent: 'flex-start',
        },
        '& $texts': {
          flexFlow: 'column',
          gap: theme.spacing(0.5),
        },
      },
    },
    content: {
      flex: 1,
      display: 'flex',
      flexFlow: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(2),
    },
    texts: {
      display: 'flex',
    },
    row: {
      display: 'flex',
      flexFlow: 'row',
      alignItems: 'center',
    },
    text: {
      color: COLORS.neutral.white,
    },
    buttonContained: {
      ...theme.typography.medium14,
      height: 'auto',
      padding: theme.spacing(1, 1.5),
      backgroundColor: COLORS.gray.white,
      color: COLORS.primary.active,

      '&:hover': {
        backgroundColor: alpha(COLORS.gray.white, 0.9),
      },
    },
    buttonOutlined: {
      ...theme.typography.medium14,
      height: 'auto',
      padding: theme.spacing(1, 1.5),
      color: COLORS.neutral.black,
      borderColor: 'transparent',
      backgroundColor: COLORS.gray.white,

      '&:hover': {
        backgroundColor: alpha(COLORS.gray.white, 0.8),
      },
    },
    buttonText: {
      ...theme.typography.medium12,
      height: 'auto',
      padding: 0,
      color: COLORS.neutral.white,
      marginLeft: theme.spacing(0.5),

      '& span': {
        padding: theme.spacing(0, 0.25),
        borderBottom: `1px solid ${COLORS.neutral.white}`,
        '&:hover': {
          borderColor: 'transparent',
        },
      },
    },
    informationIcon: {
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.neutral.black,
      marginLeft: theme.spacing(0.5),

      '&:hover': {
        color: alpha(COLORS.neutral.black, 0.9),
      },
    },
    labelRowsExplanation: {
      color: COLORS.neutral.white,
    },
    iconArrow: {
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.neutral.white,
    },
  }),
  { name: 'PerformanceRowsLimitedBanner' }
);
